import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/login')({
  component: () => null, // Never renders
  loader: () => {
    throw redirect({ to: '/$locale/sign-in', params: { locale: 'en' }, search: { error: undefined } })
  },
})
